import React from 'react';
export function PrivacyPolicy() {
  return <div className="w-full bg-white py-16" data-id="element-421">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-422">
        <h1 className="text-4xl font-bold text-slate-800 mb-8" data-id="element-423">
          Privacy & Cookie Policy
        </h1>
        <div className="prose prose-slate max-w-none" data-id="element-424">
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-425">
            Who We Are
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-426">
            Brighthands is a UK-based appliance repair business specialising in
            domestic diagnostics, repairs, and maintenance services. We are
            committed to protecting your privacy and handling your data
            responsibly.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-427">
            Data We Collect
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-428">
            When you book a repair service with us, we collect:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-429">
            <li data-id="element-430">Contact information (name, phone number, email address)</li>
            <li data-id="element-431">Property address where the repair will take place</li>
            <li data-id="element-432">
              Booking data (appointment dates, appliance type, fault details)
            </li>
            <li data-id="element-433">Payment confirmations (processed securely through Stripe)</li>
          </ul>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-434">
            How We Use Your Data
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-435">We use your information to:</p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-436">
            <li data-id="element-437">Manage and complete your repair bookings</li>
            <li data-id="element-438">Send appointment confirmations and service updates</li>
            <li data-id="element-439">Process payments securely</li>
            <li data-id="element-440">Comply with legal and regulatory requirements</li>
            <li data-id="element-441">Improve our services and customer experience</li>
          </ul>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-442">
            Data Sharing
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-443">
            We only share your data with trusted service providers necessary for
            our operations:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-444">
            <li data-id="element-445">
              <strong data-id="element-446">Stripe:</strong> For secure payment processing
            </li>
            <li data-id="element-447">
              <strong data-id="element-448">Hosting providers:</strong> For website and email services
            </li>
          </ul>
          <p className="text-slate-600 mb-6" data-id="element-449">
            We do not sell or rent your personal information to third parties.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-450">
            Data Retention
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-451">
            We retain your personal data only as long as necessary to provide
            our services and comply with legal obligations. Booking records are
            typically kept for 7 years for accounting and tax purposes. After
            this period, data is securely deleted.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-452">
            Data Security
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-453">
            We implement appropriate technical and organisational measures to
            protect your data from unauthorised access, loss, or misuse. All
            payment data is processed through Stripe's secure, encrypted
            channels.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-454">
            Cookies
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-455">
            Our website uses cookies to enhance your browsing experience:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-456">
            <li data-id="element-457">
              <strong data-id="element-458">Essential cookies:</strong> Required for the website to
              function properly
            </li>
            <li data-id="element-459">
              <strong data-id="element-460">Analytics cookies:</strong> Help us understand how
              visitors use our site and improve our services
            </li>
          </ul>
          <p className="text-slate-600 mb-6" data-id="element-461">
            You can control cookie settings through your browser preferences.
            Note that disabling essential cookies may affect website
            functionality.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-462">
            Your Rights
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-463">
            Under UK data protection law, you have the right to:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-464">
            <li data-id="element-465">
              <strong data-id="element-466">Access:</strong> Request a copy of the personal data we
              hold about you
            </li>
            <li data-id="element-467">
              <strong data-id="element-468">Rectify:</strong> Correct inaccurate or incomplete data
            </li>
            <li data-id="element-469">
              <strong data-id="element-470">Erase:</strong> Request deletion of your personal data
            </li>
            <li data-id="element-471">
              <strong data-id="element-472">Restrict:</strong> Limit how we process your data
            </li>
            <li data-id="element-473">
              <strong data-id="element-474">Object:</strong> Object to processing of your data
            </li>
            <li data-id="element-475">
              <strong data-id="element-476">Portability:</strong> Receive your data in a portable
              format
            </li>
          </ul>
          <p className="text-slate-600 mb-6" data-id="element-477">
            To exercise any of these rights, please contact us using the details
            below.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-478">
            Contact Us
          </h2>
          <p className="text-slate-600 mb-2" data-id="element-479">
            For privacy-related enquiries or to exercise your data rights:
          </p>
          <p className="text-slate-600" data-id="element-480">
            Email: Sumittandon092@gmail.com
            <br data-id="element-481" />
            Phone: 0800 055 4969
            <br data-id="element-482" />
            Address: 5 London Rd, Portsmouth PO2 0BQ
          </p>
        </div>
      </div>
    </div>;
}